var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quick-navigation"},[_c('div',{staticClass:"app-container d-flex"},[_c('div',{staticClass:"quick-navigation_wrap"},_vm._l((_vm.items),function(item,i){return _c('a',{key:`qn-${i}`,staticClass:"quick-navigation_link",attrs:{"href":item.link}},[_vm._v(_vm._s(item.title))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }